var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0801 0.546875C22.1657 0.546875 22.2514 0.546875 22.3419 0.546875C22.5519 3.14194 21.5614 5.08097 20.3576 6.48515C19.1764 7.87963 17.5589 9.23211 14.9428 9.02689C14.7683 6.46899 15.7605 4.67377 16.9627 3.27283C18.0776 1.96721 20.1217 0.805412 22.0801 0.546875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 27.5571C30 27.583 30 27.6056 30 27.6298C29.2648 29.8565 28.2161 31.7648 26.9363 33.5358C25.7681 35.1436 24.3364 37.3072 21.7801 37.3072C19.5713 37.3072 18.1041 35.8869 15.8402 35.8481C13.4455 35.8093 12.1286 37.0357 9.93914 37.3444C9.68868 37.3444 9.43822 37.3444 9.19261 37.3444C7.58483 37.1117 6.2873 35.8384 5.34202 34.6911C2.55467 31.3011 0.400732 26.9221 0 21.3183C0 20.7689 0 20.2211 0 19.6717C0.169665 15.6612 2.11839 12.4004 4.70861 10.8201C6.07562 9.97982 7.95486 9.264 10.0474 9.58394C10.9442 9.7229 11.8604 10.0299 12.6635 10.3337C13.4245 10.6262 14.3763 11.1449 15.2779 11.1174C15.8887 11.0996 16.4963 10.7813 17.1119 10.5567C18.9152 9.90549 20.683 9.15896 23.013 9.50961C25.8133 9.93296 27.8008 11.1772 29.0289 13.0968C26.66 14.6044 24.7872 16.8763 25.1072 20.756C25.3916 24.2802 27.4405 26.342 30 27.5571Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.7f8058062808bbde0e664f8fbed59ad5.svg";
export { ForwardRef as ReactComponent };